module.exports = __webpack_public_path__ + "img/1440.449dcf40.svg";